module.exports = __webpack_public_path__ + "static/media/logo-ksb.bd60a9ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-ksb.png
// module id = 173
// module chunks = 0